module.exports = __webpack_public_path__ + "static/media/05-hotspot.b9763d90.png";